import React from 'react';
import { EVENT_LABELS, reasonLabel } from './platesConfig';

export function fmtDate(iso, opts = { day: '2-digit', month: 'short', year: 'numeric' }) {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('es-MX', opts); }
  catch { return String(iso); }
}

export function fmtDateTime(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString('es-MX', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    });
  } catch { return String(iso); }
}

export function getInitials(name = '') {
  return name.split(' ').filter(Boolean).slice(0, 2).map(w => w[0]?.toUpperCase()).join('');
}

export function ContextHeader({ cliente, vehiculo, contrato, compact = false, dark = false }) {
  const size = compact ? 40 : 48;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <div className="avatar" style={{ width: size, height: size, fontSize: compact ? 13 : 15 }}>
        {getInitials(cliente || '')}
      </div>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: compact ? 14 : 15, fontWeight: 600, color: dark ? '#fff' : 'var(--pei-text)' }}>
          {cliente || '—'}
        </div>
        <div style={{ fontSize: 12, color: dark ? 'rgba(255,255,255,0.7)' : 'var(--pei-text-helper)', marginTop: 2, display: 'flex', alignItems: 'center', gap: 8 }}>
          <span>{vehiculo || ''}</span>
          {vehiculo && contrato ? <span style={{ opacity: 0.5 }}>·</span> : null}
          {contrato ? <span style={{ fontFamily: 'var(--pei-font-mono)', fontSize: 11 }}>{contrato}</span> : null}
        </div>
      </div>
    </div>
  );
}

export function InfoRow({ label, value }) {
  return (
    <div>
      <div style={{ fontSize: 10.5, fontWeight: 600, color: 'var(--pei-text-helper)', letterSpacing: '0.05em', textTransform: 'uppercase', marginBottom: 3 }}>
        {label}
      </div>
      <div style={{ fontSize: 14, color: 'var(--pei-text)' }}>{value}</div>
    </div>
  );
}

export function backendEventToTimelineItem(ev) {
  const meta = EVENT_LABELS[ev.event_type] || { label: ev.event_type, icon: 'pi-circle-fill', color: 'cyan' };
  const data = ev.data || {};

  let sub = null;
  switch (ev.event_type) {
    case 'email_sent':
      sub = `A ${data.to || ''}${data.cc?.length ? ' · CC: ' + data.cc.join(', ') : ''}`;
      break;
    case 'document_uploaded':
      sub = `${data.label || 'archivo'} · ${data.file_name || ''}`;
      break;
    case 'policy_amended': {
      const diff = data.diff || {};
      const parts = Object.entries(diff).map(([k, v]) => `${k}: ${v.from} → ${v.to}`);
      sub = parts.join(' · ') + (data.reason ? ` · ${reasonLabel(data.reason)}` : '');
      break;
    }
    case 'corrected': {
      const diff = data.diff || {};
      const parts = Object.entries(diff).map(([k, v]) => `${k}: ${v.from} → ${v.to}`);
      sub = parts.length ? parts.join(' · ') : 'Sin cambios de valor';
      break;
    }
    case 'cancelled':
      sub = `${reasonLabel(data.reason)}${data.effective_at ? ` · efectiva: ${fmtDateTime(data.effective_at)}` : ''}`;
      break;
    case 'provider_rejected':
      sub = reasonLabel(data.reason);
      break;
    case 'reopened':
      sub = data.mode === 'fix' ? 'Modo corrección' : 'Modo reemplazo';
      break;
    default:
      sub = null;
  }

  return {
    icon: meta.icon,
    color: meta.color,
    title: meta.label,
    sub,
    time: fmtDateTime(ev.occurred_at),
    actor: ev.user?.email || ev.user?.name || null,
    cta: ev.document_id ? 'Ver documento' : null,
  };
}
